export default __webpack_public_path__ + "static/yemi_head-66ebf676ab43f80cf839511067ea7334.png";